'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var PeerInfo = require('peer-info');

var PeerId = require('peer-id');

var protons = require('protons');

var _require = require('libp2p-record'),
    Record = _require.Record;

var _require2 = require('buffer'),
    Buffer = _require2.Buffer;

var pbm = protons(require('./dht.proto'));
var MESSAGE_TYPE = pbm.Message.MessageType;
var CONNECTION_TYPE = pbm.Message.ConnectionType;
/**
 * Represents a single DHT control message.
 */

var Message = /*#__PURE__*/function () {
  /**
   * @param {MessageType} type
   * @param {Buffer} key
   * @param {number} level
   */
  function Message(type, key, level) {
    _classCallCheck(this, Message);

    if (key && !Buffer.isBuffer(key)) {
      throw new Error('Key must be a buffer');
    }

    this.type = type;
    this.key = key;
    this._clusterLevelRaw = level;
    this.closerPeers = [];
    this.providerPeers = [];
    this.record = null;
  }
  /**
   * @type {number}
   */


  _createClass(Message, [{
    key: "clusterLevel",
    get: function get() {
      var level = this._clusterLevelRaw - 1;

      if (level < 0) {
        return 0;
      }

      return level;
    },
    set: function set(level) {
      this._clusterLevelRaw = level;
    }
    /**
     * Encode into protobuf
     * @returns {Buffer}
     */

  }, {
    key: "serialize",
    value: function serialize() {
      var obj = {
        key: this.key,
        type: this.type,
        clusterLevelRaw: this._clusterLevelRaw,
        closerPeers: this.closerPeers.map(toPbPeer),
        providerPeers: this.providerPeers.map(toPbPeer)
      };

      if (this.record) {
        if (Buffer.isBuffer(this.record)) {
          obj.record = this.record;
        } else {
          obj.record = this.record.serialize();
        }
      }

      return pbm.Message.encode(obj);
    }
    /**
     * Decode from protobuf
     *
     * @param {Buffer} raw
     * @returns {Message}
     */

  }], [{
    key: "deserialize",
    value: function deserialize(raw) {
      var dec = pbm.Message.decode(raw);
      var msg = new Message(dec.type, dec.key, dec.clusterLevelRaw);
      msg.closerPeers = dec.closerPeers.map(fromPbPeer);
      msg.providerPeers = dec.providerPeers.map(fromPbPeer);

      if (dec.record) {
        msg.record = Record.deserialize(dec.record);
      }

      return msg;
    }
  }]);

  return Message;
}();

Message.TYPES = MESSAGE_TYPE;
Message.CONNECTION_TYPES = CONNECTION_TYPE;

function toPbPeer(peer) {
  var res = {
    id: peer.id.id,
    addrs: peer.multiaddrs.toArray().map(function (m) {
      return m.buffer;
    })
  };

  if (peer.isConnected()) {
    res.connection = CONNECTION_TYPE.CONNECTED;
  } else {
    res.connection = CONNECTION_TYPE.NOT_CONNECTED;
  }

  return res;
}

function fromPbPeer(peer) {
  var info = new PeerInfo(new PeerId(peer.id));
  peer.addrs.forEach(function (a) {
    return info.multiaddrs.add(a);
  });
  return info;
}

module.exports = Message;